import { Home } from "../../components";
// import "./style.scss";

export default function HomeBVN() {
  return <Home />;
}
